import { render, staticRenderFns } from "./InvoiceCustomApprovalUsersIndex.vue?vue&type=template&id=3bdf3fc7&scoped=true&"
import script from "./InvoiceCustomApprovalUsersIndex.vue?vue&type=script&lang=js&"
export * from "./InvoiceCustomApprovalUsersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf3fc7",
  null
  
)

export default component.exports